import { css } from '@emotion/react';

import { cardContainerStyles } from '../PackageCard/PackageCard.styles';

export const cardStyles = (hasClickHandler: boolean) =>
  cardContainerStyles('vertical', false, hasClickHandler);

export const mediaWrapperStyles = css`
  position: relative;
`;

export const matchBadgeStyles = css`
  position: absolute;
  left: var(--spacing-2);
  bottom: var(--spacing-2);
  z-index: 2;
`;
